import React, { useEffect, useState } from 'react';

import { Col, Container, Form, Row } from 'react-bootstrap';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../../../Auth';
import { useAxios } from '../../../../../../AxiosHandler';
import Card from '../../../../../Shared/Card/Card';

import styles from './DogCardOwnerOverview.module.scss';

function DogCardOwnerOverview(props: DogCardOwnerOverviewProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [data, setData] = useState<any>(undefined);
    const [customData, setCustomData] = useState<any>(undefined);
    const [loading, setLoading] = useState<boolean>(true);

    const [nkkData, setNkkData] = useState<boolean>(true);
    
    function getOwnerData() {
        if (auth.selectedBreed == undefined) return;
        setLoading(true);
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + props.dogId + "/owner",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setData(res.data?.[0]);
            setLoading(false);
            props.onDataLoaded?.(res.data?.[0]);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function getCustomData() {
        if (auth.selectedBreed == undefined) return;
        setLoading(true);
        axios.single({
            method: 'post',
            url: "/api/dogs/" + props.dogId + "/additionalinfo",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" },
            data: {
                owner_name: true,
                owner_email: true,
                owner_phone: true, 
                owner_postcode: true,
                owner_postaddress: true
            },
        }).then((res) => {
            setCustomData({
                owner_name: res.data?.find((x: any) => x?.TYPE == "owner_name")?.VALUE || "",
                owner_email: res.data?.find((x: any) => x?.TYPE == "owner_email")?.VALUE,
                owner_phone: res.data?.find((x: any) => x?.TYPE == "owner_phone")?.VALUE,
                owner_postcode: res.data?.find((x: any) => x?.TYPE == "owner_postcode")?.VALUE,
                owner_postaddress: res.data?.find((x: any) => x?.TYPE == "owner_postaddress")?.VALUE
            });
        }).catch((err: any) => {
            console.log(err);
        }).finally(() => {
            setLoading(false);
        });
    }

    function saveCustomData() {
        if (auth.selectedBreed == undefined) return;
        setLoading(true);
        axios.single({
            method: 'post',
            url: "/api/dogs/" + props.dogId + "/saveadditionalinfo",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" },
            data: {
                owner_name: customData?.owner_name || "",
                owner_email: customData?.owner_email || "",
                owner_phone: customData?.owner_phone || "",
                owner_postcode: customData?.owner_postcode || "",
                owner_postaddress: customData?.owner_postaddress || "",
            }
        }).then((res) => {
            getCustomData();
        }).catch((err: any) => {
            console.log(err);
        }).finally(() => {
            setLoading(false);
        });
    }

    useEffect(() => {
        if (auth.selectedBreed != undefined) {
            getOwnerData();
            getCustomData();
        }
    }, [props.dogId]);

    return (
        <div className={styles.owneroverview}>
            <Card
                title={props.title || "Owner Overview"}
                children={<div>
                    <Form.Check 
                        className={styles.switch}
                        type="switch"
                        label={t("dog.details.owner.show_nkk_data")}
                        checked={nkkData}
                        onChange={() => {
                            setNkkData(!nkkData);
                        }}
                    />
                    <hr/>
                    { loading == false ?
                        <>
                            <table className={styles.ownertable}>
                                <tbody>
                                    {nkkData ?
                                        <>
                                            <tr>
                                                <td><strong>{t("dog.details.owner.name")}:</strong></td>
                                                <td><span style={{marginRight: "6px"}}>{data?.PERSON_LAST_NAME == "" && data?.PERSON_FIRST_NAME == "" ? data?.PERSON_LAST_NAME + ", " + data?.PERSON_FIRST_NAME : ""}</span></td>
                                            </tr>
                                            <tr>
                                                <td><strong>{t("dog.details.owner.email")}:</strong></td>
                                                <td><span style={{marginRight: "6px"}}>{data?.EMAIL_VALUE}</span></td>
                                            </tr>
                                            <tr>
                                                <td><strong>{t("dog.details.owner.phone")}:</strong></td>
                                                <td><span style={{marginRight: "6px"}}>{data?.PHONE_VALUE}</span></td>
                                            </tr>
                                            <tr>
                                                <td><strong>{t("dog.details.owner.zipcode")}:</strong></td>
                                                <td><span style={{marginRight: "6px"}}>{data?.ADDRESS_ZIP}</span></td>
                                            </tr>
                                            <tr>
                                                <td><strong>{t("dog.details.owner.postalarea")}:</strong></td>
                                                <td><span style={{marginRight: "6px"}}>{data?.ADDRESS_CITY}</span></td>
                                            </tr>
                                        </>
                                    : <>
                                        <tr>
                                            <td><strong>{t("dog.details.owner.name")}:</strong></td>
                                            <td>
                                                <input
                                                    className={styles.customownerinput}
                                                    type="text"
                                                    placeholder={data?.PERSON_LAST_NAME == "" && data?.PERSON_FIRST_NAME == "" ? data?.PERSON_LAST_NAME + ", " + data?.PERSON_FIRST_NAME : ""}
                                                    onChange={(e) => {
                                                        setCustomData({...customData, owner_name: e.target.value});
                                                    }}
                                                    value={customData?.owner_name}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><strong>{t("dog.details.owner.email")}:</strong></td>
                                            <td>
                                                <input
                                                    className={styles.customownerinput}
                                                    type="text"
                                                    placeholder={data?.EMAIL_VALUE}
                                                    onChange={(e) => {
                                                        setCustomData({...customData, owner_email: e.target.value});
                                                    }}
                                                    value={customData?.owner_email}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><strong>{t("dog.details.owner.phone")}:</strong></td>
                                            <td>
                                                <input
                                                    className={styles.customownerinput}
                                                    type="text"
                                                    placeholder={data?.PHONE_VALUE}
                                                    onChange={(e) => {
                                                        setCustomData({...customData, owner_phone: e.target.value});
                                                    }}
                                                    value={customData?.owner_phone}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><strong>{t("dog.details.owner.zipcode")}:</strong></td>
                                            <td>
                                                <input
                                                    className={styles.customownerinput}
                                                    type="text"
                                                    placeholder={data?.ADDRESS_ZIP}
                                                    onChange={(e) => {
                                                        setCustomData({...customData, owner_postcode: e.target.value});
                                                    }}
                                                    value={customData?.owner_postcode}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><strong>{t("dog.details.owner.postalarea")}:</strong></td>
                                            <td>
                                                <input
                                                    className={styles.customownerinput}
                                                    type="text"
                                                    placeholder={data?.ADDRESS_CITY}
                                                    onChange={(e) => {
                                                        setCustomData({...customData, owner_postaddress: e.target.value});
                                                    }}
                                                    value={customData?.owner_postaddress}
                                                />
                                            </td>
                                        </tr>
                                    </>}
                                </tbody>
                            </table>
                            {!nkkData ? 
                                <>
                                    <hr/>
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => {
                                            saveCustomData();
                                        }}
                                    >
                                        {t("dog.details.owner.save")}
                                    </button>
                                </>
                            : null }
                        </>
                    : <div>{t("dog.details.loading")}</div>}
                </div>}
            ></Card>
        </div>
    );
}

class DogCardOwnerOverviewProps {
    title?: string;
    dogId!: string | undefined;
    statusDisabled?: boolean;
    onDataLoaded?: (data: any) => void;
}

export default DogCardOwnerOverview;